import React from "react"

import { WithClassName } from "shared/types/WithClassName"
import { PriceGroup } from "shared/types/__generated__/graphql"
import { PriceGroups } from "shared/ui/price-groups/PriceGroups"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormPriceGroupsProps extends WithClassName {
  groups?: PriceGroup[] | null
  isLoading?: boolean
  isUpdating?: boolean
}

export const ProjectFormPriceGroups = React.memo(
  ({
    groups: groupsProp,
    isLoading: isLoadingProp,
    isUpdating: isUpdatingProp,
    className
  }: ProjectFormPriceGroupsProps) => {
    const { model } = useProjectFormContext()
    const price = model?.pricing.data.price

    const groups = groupsProp ?? price?.data?.groups
    const isLoading = isLoadingProp ?? price?.isLoading
    const isUpdating = isUpdatingProp ?? price?.isUpdating

    return (
      <div className="project-form__price-groups">
        <PriceGroups
          groups={groups}
          isLoading={isLoading}
          isUpdating={isUpdating}
          className={className}
        />
      </div>
    )
  }
)

ProjectFormPriceGroups.displayName = "ProjectFormPriceGroups"
